<template>
  <v-container
    v-if="AppConfig.Marketplace.ScheduledOrder.Active"
    class="pa-0"
    fluid
  >
    <v-row dense>
      <v-col cols="12">
        <v-expansion-panels
          accordion
          flat
        >
          <v-expansion-panel class="transparent">
            <v-expansion-panel-header class="px-0 py-1 brand-green-dark--text">
              <div>
                <div class="d-flex">
                  <v-icon
                    class="mr-6"
                    color=" brand-green-dark"
                  >
                    mdi-clock
                  </v-icon>

                  <span class="brand-text-heading">{{ $t('Cart.ScheduledOrder.Title').toLocaleUpperCase($i18n.locale) }}</span>
                </div>

                <div class="ml-12 mt-1">
                  {{ scheduledOrderSubtitle }}
                </div>
              </div>
            </v-expansion-panel-header>

            <v-expansion-panel-content class="cart-schedule-order">
              <v-sheet
                class="pl-12 rounded"
                color="transparent"
              >
                <v-radio-group
                  v-model="scheduledOrder"
                  :disabled="scheduledLoading"
                  class="mt-0"
                  hide-details
                  mandatory
                  @change="setModelValue('scheduledOrder')"
                >
                  <v-radio
                    :disabled="scheduledLoading"
                    class="rounded pa-3"
                    color="brand-green-dark"
                    style="border: var(--v-brand-green-base) 1px solid;"
                    value="now"
                  >
                    <template #label>
                      <div>
                        <div class="brand-green-dark--text">
                          {{ $t('Cart.ScheduledOrder.Default.Title') }}
                        </div>
                        <div class="brand-grey--text">
                          {{ cartStoresMinMaxTime }} {{ $tc('Common.Date.Minute', 0) }}
                        </div>
                      </div>
                    </template>
                  </v-radio>

                  <v-radio
                    :disabled="scheduledLoading"
                    class="rounded pa-3"
                    color="brand-green-dark"
                    style="border: var(--v-brand-green-base) 1px solid;"
                    value="scheduled"
                  >
                    <template #label>
                      <div>
                        <div class="brand-green-dark--text">
                          {{ $t('Cart.ScheduledOrder.Custom.Title') }}
                        </div>
                        <div class="brand-grey--text">
                          {{ $t('Cart.ScheduledOrder.Custom.Collection') }}
                        </div>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>

                <v-slide-y-transition>
                  <div
                    v-show="scheduledOrder === OrderTimeEnum.SCHEDULED"
                    class="mt-3"
                  >
                    <v-container
                      fluid
                      pa-0
                    >
                      <v-row dense>
                        <v-col cols="6">
                          <v-select
                            v-model="scheduledOrderDate"
                            :dense="$vuetify.breakpoint.xsOnly"
                            :disabled="scheduledLoading"
                            :items="scheduledOrderDates"
                            :label="$tc('Common.Date.Day', 1)"
                            color="brand-green"
                            hide-details
                            item-text="Name"
                            item-value="Value"
                            outlined
                            return-object
                            @change="setModelValue('scheduledOrderDate')"
                          />
                        </v-col>

                        <v-col cols="6">
                          <v-select
                            v-model="scheduledOrderTime"
                            :dense="$vuetify.breakpoint.xsOnly"
                            :disabled="scheduledLoading"
                            :items="scheduledOrderTimes"
                            :label="$tc('Common.Date.Hour', 1)"
                            color="brand-green"
                            hide-details
                            item-text="Name"
                            item-value="Value"
                            outlined
                            return-object
                            @change="setModelValue('scheduledOrderTime')"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </div>
                </v-slide-y-transition>
              </v-sheet>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import ScheduledOrderMixin from '@/theme/default/components/cart/ScheduledOrder.js'

export default {
  name  : 'ScheduledOrder',
  mixins: [ScheduledOrderMixin]
}
</script>

<style scoped src="@/theme/default/components/cart/ScheduledOrder.css"></style>

<style scoped>
</style>
